import {AddIcon} from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import {useMutation, useQueryClient} from "react-query";

import {postAnswersExcel, postDataJson as apiImport} from "../../shared/Api";
import {errorToast, infoToast, successToast} from "../../shared/helper/ToastHelper";
import {ValidExcelTypes, ValidJsonTypes} from "../../shared/model/Constants";
import {adminKeys} from "../../shared/QueryKeys";

const UploadAnswers = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);

  const uploadDataJson = useMutation(apiImport, {
    onSuccess: () => {
      successToast(toast, "Se actualizó la base de datos");
      setUploading(false);
      return queryClient.invalidateQueries(adminKeys.candidates());
    },
    onError: () => {
      setUploading(false);
      errorToast(toast, "Error subiendo datos");
    },
  });

  const uploadAnswersExcel = useMutation(postAnswersExcel,
    {
      onSuccess: (TData) => {
        successToast(toast, `Se agregaron ${TData.data} respuestas`);
        setUploading(false);
        return queryClient.invalidateQueries(adminKeys.candidateAnswers());
      },
      onError: () => {
        setUploading(false);
        errorToast(toast, "Error subiendo repuestas");
      },
    }
  );
  
  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  function handleClick() {
    if (file) {
      const extension = file.name.split('.').pop() || "";
      if (ValidJsonTypes.includes(extension)) {
        infoToast(toast, "Agregando datos");
        setUploading(true);
        file.text().then(txt => uploadDataJson.mutate(txt));
      }
      else if (ValidExcelTypes.includes(extension)) {
        setUploading(true);
        infoToast(toast, "Agregando respuestas");
        uploadAnswersExcel.mutate(file);
      }
      else
        errorToast(toast, "El archivo seleccionado no tiene un formato válido");
    }
    onClose();
  }

  return (
      <>
        <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={onOpen} disabled={uploading}>
          Agregar respuestas
        </Button>
        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Nuevas respuestas</ModalHeader>
            <ModalBody>
              <FormControl id="file-form-control" paddingBottom="6">
                <FormLabel>Respuestas</FormLabel>
                <input name="file-input" type="file" onChange={handleChange} accept=".xlsx, .xls, .ods, .csv, .json" />
                <FormHelperText>
                  Seleccione un archivo en formato xlsx o json.
                </FormHelperText>
              </FormControl>
            </ModalBody>
            <ModalCloseButton />
            <ModalFooter>
              <Button
                  colorScheme="teal"
                  type="submit"
                  isDisabled={!file}
                  onClick={handleClick}
                  disabled={uploading}
              >
                Agregar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
  );
};

export default UploadAnswers;
